// extracted by mini-css-extract-plugin
export default {"flexBox":"UserCard_flexBox__KJqlb","profile":"UserCard_profile__viGWw","infoBox":"UserCard_infoBox__3pa1I","name":"UserCard_name__cInfE","desBox":"UserCard_desBox__JA5-m"};